// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalEligibilityResultSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalEligibilityResultSearchDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalEligibilityResultSearchDefaultResponseData.discriminator = undefined;
MedicalV1MedicalEligibilityResultSearchDefaultResponseData.additionalProperties = false;
MedicalV1MedicalEligibilityResultSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "results",
        "baseName": "results",
        "type": ""
    },
];
//# sourceMappingURL=medicalV1MedicalEligibilityResultSearchDefaultResponseData.js.map